var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/reviews.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-meta/reviews.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_6 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_6);
var t_7;
t_7 = (lineno = 1, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.hideReviews",""]));
frame.set("displayReviews", t_7, true);
if(frame.topLevel) {
context.setVariable("displayReviews", t_7);
}
if(frame.topLevel) {
context.addExport("displayReviews", t_7);
}
if(!runtime.contextOrFrameLookup(context, frame, "displayReviews")) {
output += "\n\n    ";
var t_8;
t_8 = (lineno = 5, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "round_step"), "round_step", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"averageRating"),10]));
frame.set("avgRating", t_8, true);
if(frame.topLevel) {
context.setVariable("avgRating", t_8);
}
if(frame.topLevel) {
context.addExport("avgRating", t_8);
}
output += "\n    ";
var t_9;
t_9 = "c-star-review-" + "" + env.getFilter("replace").call(context, (lineno = 6, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "round_step"), "round_step", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"averageRating"),2])),".","_");
frame.set("avgRatingClass", t_9, true);
if(frame.topLevel) {
context.setVariable("avgRatingClass", t_9);
}
if(frame.topLevel) {
context.addExport("avgRatingClass", t_9);
}
output += "\n\n    ";
output += "\n    <span class=\"c-star-review-outer\">\n\n        <span class=\"c-star-review ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "avgRatingClass"), env.opts.autoescape);
output += "\" data-qa-ratings>\n\n            ";
output += runtime.suppressValue((lineno = 13, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-stars",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "avgRating")]})])), env.opts.autoescape);
output += "\n\n        </span>\n\n    </span>\n\n    ";
output += "\n    <span class=\"c-star-review__rating\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "avgRating"), env.opts.autoescape);
output += "</span><span class=\"c-product-reviews__count\">";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"TotalResults");
frame.set("reviewsCount", t_10, true);
if(frame.topLevel) {
context.setVariable("reviewsCount", t_10);
}
if(frame.topLevel) {
context.addExport("reviewsCount", t_10);
}
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += runtime.suppressValue((lineno = 26, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "reviewsCount")]})])), env.opts.autoescape);
;
}
else {
output += "\n            <a\n                href=\"#\"\n                class=\"c-product-reviews__count-link js-product-reviews-link\"\n                ";
output += runtime.suppressValue((lineno = 34, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","reviews click","review count | " + "" + runtime.contextOrFrameLookup(context, frame, "reviewsCount")])), env.opts.autoescape);
output += "\n            >";
output += runtime.suppressValue((lineno = 35, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "reviewsCount")]})])), env.opts.autoescape);
output += "</a>";
;
}
output += "</span>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/reviews.j2"] , dependencies)